import { render } from "./HHPatientMain.vue?vue&type=template&id=49d91a84&ts=true"
import script from "./HHPatientMain.ts?vue&type=script&lang=ts&external"
export * from "./HHPatientMain.ts?vue&type=script&lang=ts&external"

import "./HHPatientMain.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__